
/// <amd-module name="DistributedTaskUI/SecurityComponent/Constants" />
export const viewParameter: string = "view";
export const definitionScopeParameter: string = "definitionScope";
export const buildDefinitionRequestTypeRecent: string = "recent";
export const buildDefinitionRequestTypeAllDefinitions: string = "allDefinitions";
export const recentGroupType: string = "recent";
export const allGroupType: string = "all";
export const YAMLProcessType: number = 2;

export const Area = "PipelineAuthorization";

export namespace FeatureNames {
    export const OpenAccess = "Open_Access";
    export const RestrictAccess = "Restrict_Access";
    export const AddPipeline = "Add_Pipeline";
    export const RemovePipeline = "Remove_Pipeline";
}

export const enum SecurityNamespaceConstants {
    NamespaceSeparator = "/",
    Endpoints = "endpoints",
    Collection = "Collection",
    NamespaceId = "49B48001-CA20-4ADC-8111-5B60C903A50C",
    AdminPermission = 2,
    ProjectScopeId = "distributedtask.serviceendpointrole",
    ProjectRootScopeId = "distributedtask.project.serviceendpointrole",
    CollectionScopeId = "distributedtask.collection.serviceendpointrole"
}